import { AnyAction } from 'redux';
import {
  ITokenResponse,
  IUserInfoResponse,
}                    from '@typings/auth';

const namespace = 'AUTH';

export const LOGIN_SUCCEED               = `${namespace}/LOGIN_SUCCEED`;
export const LOGOUT_SUCCEED              = `${namespace}/LOGOUT_SUCCEED`;
export const FETCH_AUTH_INFO_SUCCEED     = `${namespace}/FETCH_AUTH_INFO_SUCCEED`;

export const loginSucceed = (payload: ITokenResponse): AnyAction => ({
  type: LOGIN_SUCCEED,
  payload,
});

export const logoutSucceed = (): AnyAction => ({
  type: LOGOUT_SUCCEED,
});

export const fetchAuthInfoSucceed = (payload: IUserInfoResponse): AnyAction => ({
  type: FETCH_AUTH_INFO_SUCCEED,
  payload,
});
